import React from 'react';
import { LazyGigPageMultiBanner } from '@fiverr-private/upmarket_banners';
import { BannerWrapper } from '../components/BannerWrapper';

export const MultiBanner: React.FC = () => (
  <BannerWrapper>
    <LazyGigPageMultiBanner />
  </BannerWrapper>
);
